import React from 'react'
import { Helmet } from 'react-helmet'
import { get } from 'lodash'
import connect from './tools/connect'
import initializeSkin from './tools/skinAd/index'
import updateUtm from './tools/analytics/utm'
import pageStore from './redux/page/store'
import PopupView from './views/Popup'
import Share from './views/Share'
import ErrorPage from './views/ErrorPage'
import CookieConsent from '~/components/CookieConsent'
import AppStoreSuggestion from '~/components/AppStoreSuggestion'
import { trackEvent } from '~/tools/analytics/cleverTap'
import { nestTabModules, applyModuleData } from "~/Modules"
import SkeletonLoader from '~/components/skeletonLoader'
import PageSpinner from '~/components/PageSpinner'
import lazyLoad from './tools/lazy-load-images'
import NavFocusSkipper from '~/components/NavFocusSkipper'
import { ima3, platform } from './tools/externalSDK'
import { signupOrSignIn } from '~/tools/signupOrSignIn'
import loadFreshChatBot from './tools/analytics/freshChatBot'
import { trackEventFunnel } from "~/tools/analytics/googleAnalytics";
import Cookies from 'js-cookie'
import userStore from './redux/user/store'
import './App.css'
import { getLocalizedVal } from '~/tools/localization/helpers';
// import MiniStandaloneVideoPlayer from '~/modules/NewsStandaloneVideoPlayer/miniplayer';
/*  
    Most pages use slick so we are importing it at the Base 
    so that these imports are not needed 
    everytime the <Slider /> component is used.
*/
import 'slick-carousel/slick/slick.css'
import '~/modules/Carousel/slick-theme.css'
import '~/modules/Carousel/style.scss'
import LazyLoadModules from './LazyLoadModules';
import TabNavBar from '~/components/TabNavBar'
import {updatepageStyle} from '~/tools/getPageLevelStyling'
import { setGetSocialCId } from "~/tools/analytics/getSocialEvent";
import { subscribeNotificationWs } from './redux/user/helpers'
import { adsRemarketingEvent, webConfigurationEvent } from '~/tools/analytics/gtmTags'
import { deferredInitCookieBot, deferredCookieDeclaration } from '~/tools/analytics/cookieBot'

import initializeGtm from './tools/analytics/gtm'
import { initGa , initEnhancedECommerce } from './tools/analytics/googleAnalytics'
import { initializeWebWorker, initializeServiceWorker, removePushNotification, getRemovePushNotificationFlag } from './tools/webWorker'
import initFbEvent from './tools/analytics/fbEvent';
import { initGtmAdwords } from './tools/analytics/gtmTags';
import getDeviceInfo from './tools/userEnvironment/getDeviceInfo';

class App extends React.Component {
  
  constructor() {
    super()
    this.showCookieConsent = this.shouldShowCookieConsent()
    this.myRef = React.createRef();
    this.loadMore = false
    this.state = {
      pageReload : false,
      MiniStandaloneVideoPlayer: null
    }
  }

  // TEMPORARY: whether we show the cookie consent or not should depend on an AppCMS setting
  shouldShowCookieConsent() {
    return !window.settings.internalName.includes('hoichoi') && !window.settings.internalName.includes('universal')
  }

  componentDidMount() {
    const removePushNotificationFlag = getRemovePushNotificationFlag();
    setGetSocialCId();
    updateUtm();
    getDeviceInfo();
    if(get(window.settings, 'isMonetizationModelEnabled')){
      if(!get(window, 'google.ima')){
        ima3()
      }
    }else{
      get(window.settings, 'advertising.videoTag') && ima3()
    }
    
    platform()
    initializeSkin(get(this.state, 'page.data.id'))
    setTimeout(lazyLoad, 2000)
    window && window.settings && window.settings.features && window.settings.features.enablePWA && window.addEventListener('beforeinstallprompt',event => { window.deferredPrompt = event })
    document.addEventListener("scroll", lazyLoad);
    window.addEventListener("resize", lazyLoad);
    window.addEventListener("orientationchange", lazyLoad)
    const userInfo = userStore.getState().user || {};
    if (!window.SERVER_SIDE_RENDERING && window.sessionStorage && !window.sessionStorage.getItem('isApp')) {
      deferredInitCookieBot();
    }
    if (userInfo && userInfo.isSubscribed === false && userInfo.subscriptionStatus !== "COMPLETED") 
      Cookies.get('isPaymentinProcess') && subscribeNotificationWs();
    else Cookies.remove('isPaymentinProcess');
    
    removePushNotificationFlag && removePushNotification();
    initializeServiceWorker()
    initGa()
    if (window.settings.serviceType === 'SVOD') {
      initEnhancedECommerce()
    }
    initializeWebWorker()
    initGtmAdwords()
    initializeGtm()
    initFbEvent()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.page !== prevState.page) {
      var { title } = this.state.page || {}

      adsRemarketingEvent('page_view', {
        'source': 'Web', 
        'pageName': title,
        'Login-Signup' : signupOrSignIn()
        }
      );
      webConfigurationEvent('page_view', {
        'source': 'Web', 
        'pageName': title
      })
      loadFreshChatBot();

      if (!window.SERVER_SIDE_RENDERING && window.sessionStorage && !window.sessionStorage.getItem('isApp')) {
        deferredCookieDeclaration();
      }

      if(!this.state.MiniStandaloneVideoPlayer){
        this.addMiniStandalonePlayer();
      }
    }
  }

  triggerPageViewd() {
    var { title } = this.state.page || {}
    if (title) {
      var lastActivity = null
      if (document.referrer && document.referrer !== window.location.href) {
        lastActivity = document.referrer
      }

      if((title.toLowerCase()).includes("plans")){
        Cookies.set('viewPlans', true);
        trackEventFunnel("trackFunnel", "viewPlans")
      }
      
      trackEvent('Page Viewed', {
        pageName: title,
        pageURL: window.location.href,
        lastActivityName: lastActivity,
        source: lastActivity,
        platform: 'Web'
      })
        
      const socialMedia = window.settings.socialMedia
      const facebook = socialMedia && socialMedia.facebook 
      const pixelId = facebook && facebook.pixelId
      if (pixelId) {
        window.fbq('track', 'PageView');
      }
    }
  }

  addMiniStandalonePlayer = () => {
    let add_site_level_mini_player = window.settings.features.add_site_level_mini_player;
    let { layouts } = this.state.page || {};

    if(!add_site_level_mini_player || !layouts) return;
    if(layouts.length){
      for(let layout of layouts){
        // whitelist current mini player for smooth deployment
        if(layout.type === 'AC StandaloneVideoPlayer 03') return true;
        // not display mini player on page with a standalone video player or VideoPlayerWithInfo
        else if(layout.type.includes('StandaloneVideoPlayer') || layout.type.includes('VideoPlayerWithInfo')) return;
      }
    }
    if(add_site_level_mini_player){
      import('~/modules/NewsStandaloneVideoPlayer/miniplayer')
      .then(MiniStandaloneVideoPlayer=>{
        this.setState({
            MiniStandaloneVideoPlayer: MiniStandaloneVideoPlayer.default
        });
      })
    }
  }

  render() {
    var { modules, layouts } = this.state.page || {}
    var classes = ['app', 'appcms', window.SERVER_SIDE_RENDERING ? 'server-side-rendering' : '']
    var currentPage = window.location.pathname;
    const isPWAEnabled = (window && window.settings && window.settings.features && window.settings.features.enablePWA) || false;
    const isPWALogo = window.settings.images && window.settings.images.pwaLogo;
    let languageCode = Cookies.get("userLanguageSelection")
    const defaultLangCode = window.settings && window.settings.languages && window.settings.languages.default && window.settings.languages.default.code
    languageCode =  (languageCode === "") || !(languageCode) ? (defaultLangCode ? defaultLangCode : "en") : languageCode 
    const userInfo = userStore.getState().user || {};
    let deviceLimitError = Cookies.get('MAX_DEVICE_ERROR') 
    let removeDeviceError = Cookies.get('remove_error')
    // override styling with page specific styling if flag enabled
    if(get(this.state, 'page.styles.enableStyle') === true) {
      updatepageStyle(this.state.page && this.state.page.styles);
    }
    let userDevicesExceedError = getLocalizedVal(window.settings,'genericMessages', 'userDevicesExceedError') || 'User has exceeded the device limit. Go to device management and remove the devices.';
    let fontBackgroundColor = window.settings.brand && window.settings.brand.cta && window.settings.brand.cta.primary.backgroundColor
    let fontColor = window.settings.brand && window.settings.brand.cta && window.settings.brand.cta.primary.textColor
    let fontStyle = {
      backgroundColor : fontBackgroundColor,
      color: fontColor
    }
    if (this.state.fetchingPage || this.state.adobeStatus) {
      if (currentPage.includes("/user")) {
        return !window.SERVER_SIDE_RENDERING && <PageSpinner color={window.settings.brand.cta.primary.backgroundColor} />
      } else {
        return !window.SERVER_SIDE_RENDERING && <SkeletonLoader />
      }
    }
    const { MiniStandaloneVideoPlayer } = this.state;

    return (
      <div ref={el => this.wrapper = el}>
        <div ref={this.myRef} className={classes.join(' ')}>
          <NavFocusSkipper />
          
          <Helmet
            onChangeClientState={(newState) => this.triggerPageViewd(newState.title)}>
            <link rel="alternate" href={window.location.href} hreflang={languageCode} />
            {window.settings.brand.general.fontUrl && <link href={`${window.settings.brand.general.fontUrl}&display=swap`} rel="stylesheet" />}
            {isPWAEnabled && <meta name="apple-mobile-web-app-capable" content="yes"/>}
            {isPWAEnabled && <meta name="apple-mobile-web-app-status-bar-style" content="black"/>}
            {isPWAEnabled && <meta name="apple-mobile-web-app-title" content={(window.settings && window.settings.site) || ""}/>}
            {isPWAEnabled && isPWALogo && isPWALogo.pwaLogo72x72 && <link rel="apple-touch-icon" sizes="72x72" href={(isPWALogo && isPWALogo.pwaLogo72x72) || "" }/>}
            {isPWAEnabled && isPWALogo && isPWALogo.pwaLogo96x96 && <link rel="apple-touch-icon" sizes="96x96" href={(isPWALogo && isPWALogo.pwaLogo96x96) || "" }/>}
            {isPWAEnabled && isPWALogo && isPWALogo.pwaLogo128x128 && <link rel="apple-touch-icon" sizes="128x128" href={(isPWALogo && isPWALogo.pwaLogo128x128) || "" }/>}
            {isPWAEnabled && isPWALogo && isPWALogo.pwaLogo144x144 && <link rel="apple-touch-icon" sizes="144x144" href={(isPWALogo && isPWALogo.pwaLogo144x144) || "" }/>}
            {isPWAEnabled && isPWALogo && isPWALogo.pwaLogo152x152 && <link rel="apple-touch-icon" sizes="152x152" href={(isPWALogo && isPWALogo.pwaLogo152x152) || "" }/>}
            {isPWAEnabled && isPWALogo && isPWALogo.pwaLogo192x192 && <link rel="apple-touch-icon" sizes="192x192" href={(isPWALogo && isPWALogo.pwaLogo192x192) || "" }/>}
            {isPWAEnabled && isPWALogo && isPWALogo.pwaLogo384x384 && <link rel="apple-touch-icon" sizes="384x384" href={(isPWALogo && isPWALogo.pwaLogo384x384) || "" }/>}
            {isPWAEnabled && isPWALogo && isPWALogo.pwaLogo512x512 && <link rel="apple-touch-icon" sizes="512x512" href={(isPWALogo && isPWALogo.pwaLogo512x512) || "" }/>}
            {isPWAEnabled && isPWALogo && isPWALogo.pwaLogo512x512 && <link rel="apple-touch-startup-image" href={(isPWALogo && isPWALogo.pwaLogo512x512) || "" }/>}
            {isPWAEnabled && <meta name="theme-color" content={(window.settings && window.settings.brand && window.settings.brand.general && window.settings.brand.general.backgroundColor) || "#000000"} />}
          </Helmet>
          {window.settings.skinAdTag && <div id="viewlift-site-skin"></div>}
          
          <div role="main" className={`modules ` + (window.settings.skinAdTag && 'skin-ad')}>
            {((userInfo && userInfo.code === 'DEVICE_LIMIT_EXCEEDED') || deviceLimitError) && !removeDeviceError && <div style={fontStyle} className="deviceError">{userDevicesExceedError}</div>}
            {this.loaded && window.settings.features.app_download_suggestion &&
              <AppStoreSuggestion />
            }
            {MiniStandaloneVideoPlayer && <MiniStandaloneVideoPlayer/>}
            {
              this.loaded &&
              this.renderModules(layouts, modules)
            }
            <LazyLoadModules pageReload={this.loadMore} layouts={layouts} page={this.state.page}/>
          </div>
          {window && window.settings && window.settings.features && window.settings.features.enablePWA && <TabNavBar/>}
          {this.showCookieConsent &&
            <CookieConsent />
          }
          {this.errored && <ErrorPage error={this.state.page.error} />}
          {this.loaded && <PopupView />}
          {this.loaded && <Share />}
        </div>
      </div>
    )
  }

  get errored() {
    return this.state.page.error != null;
  }

  get loaded() {
    return this.state.page && !this.state.page.error
  }

  renderModules(layouts, modules) {
    /*
        This nestTabModules conditional was added because the Template Builder does not currently
        have a way to support nesting. This is basically a hacky workaround that splits up the modules
        and nests them for pages that have a Tabs Module.
    */
    let tabModule = layouts.filter(moduleLayout => {
      if (!moduleLayout.view) {
        return false;
      }
      return moduleLayout.view.includes('Tabs');
    })

    if (tabModule.length > 0) {
      return nestTabModules(layouts, modules, tabModule);
    }
    else {
      return applyModuleData(layouts, modules)
    }
  }
}

connect(App, state => ({ page: state.data, fetchingPage: state.fetchingPage, adobeStatus: state.adobeStatus }), pageStore)

export default App;
